import { render, staticRenderFns } from "./FilterBarDemographics.vue?vue&type=template&id=1d1af67a&scoped=true&"
import script from "./FilterBarDemographics.vue?vue&type=script&lang=js&"
export * from "./FilterBarDemographics.vue?vue&type=script&lang=js&"
import style0 from "./FilterBarDemographics.vue?vue&type=style&index=0&id=1d1af67a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1af67a",
  null
  
)

/* custom blocks */
import block0 from "./FilterBarDemographics.vue?vue&type=custom&index=0&blockType=i18n&locale=en-us&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./FilterBarDemographics.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports
import {QCard,QCardSection,QBtnDropdown,QSelect,QCardActions,QBtn,Scroll} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QBtnDropdown,QSelect,QCardActions,QBtn})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Scroll})
